import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AUTH_STATUS, useAuth } from "../../auth";

export interface IProtectedRoute {
  children: any;
}

const ProtectedRoute = ({ children }: IProtectedRoute) => {
  const prevLocation = useLocation();
  const { authStatus, readyState } = useAuth();

  // While auth state is being read from sessionStorage, render nothing to
  // prevent a flash of protected content before the redirect to login.
  if (!readyState) {
    return null;
  }

  if (authStatus === AUTH_STATUS.AUTHENITCATED) {
    return <>{children}</>;
  }

  return <Navigate to={`/login?redirectTo=${prevLocation?.pathname}`} />;
};
export default ProtectedRoute;
